import {css} from '../theme/css'
import {spacing} from '../theme/theme'
import {cssTheme} from '../v2'
import {BackgroundColor, BorderRadiusVariants, PaddingVariants} from './types'

const rootColors: Record<`root_${BackgroundColor}`, string> = {
  root_main: css`
    background-color: ${cssTheme.default.day.background};
  `,
  root_minor: css`
    background-color: ${cssTheme.default.day.backgroundMinor};
  `,
  root_invert: css`
    background-color: ${cssTheme.default.day.backgroundInvert};
  `,
}

const borderRadiusVariants: Record<`root_border_radius_${BorderRadiusVariants}`, string> = {
  root_border_radius_M: css`
    border-radius: ${cssTheme.spacingUnits.m};
  `,
  root_border_radius_L: css`
    border-radius: ${cssTheme.spacingUnits.l};
  `,
}

const paddingVariants: Record<`root_padding_${PaddingVariants}`, string> = {
  root_padding_none: css`
    padding: 0;
  `,
  root_padding_XS: css`
    padding: ${cssTheme.spacingUnits.xs};
  `,
  root_padding_S: css`
    padding: ${cssTheme.spacingUnits.s};
  `,
  root_padding_M: css`
    padding: ${cssTheme.spacingUnits.m};
  `,
  root_padding_L: css`
    padding: ${cssTheme.spacingUnits.l};
  `,
  root_padding_XL: css`
    padding: ${cssTheme.spacingUnits.xl};
  `,
  root_padding_XXL: css`
    padding: ${spacing(5)};
  `,
}

export const classes = {
  root: css`
    display: flex;
    flex-direction: column;
    height: 100%;
    box-sizing: border-box;
  `,
  ...rootColors,
  ...borderRadiusVariants,
  ...paddingVariants,
}
